<template>
  <div class="form-wrapper">
    <LmComponentLoading v-if="loading" fixed />
    <form
      :id="id"
      novalidate
      class="position-relative"
      @submit.prevent
      >
      <slot :isOnEditMode="isOnEditMode">
      </slot>
    </form>
  </div>
</template>

<script>
import lmFormMixinV2 from '@/mixins/lmFormMixinV2.js'

export default {
  mixins: [lmFormMixinV2]
}
</script>
